export const GET_OPERADORES_MONGO = 'GET_OPERADORES_MONGO'
